import React from "react";
import { Paper } from "@mui/material";

function TermsOfServicePage() {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 1,
                overflow: 'auto',
                height: 'var(--app-height)',
            }}>
            <div>
                <h1>Terms of Service</h1>

                <h2>1. Overview</h2>
                <p>
                    Welcome to <a href="https://superfastgpt.com">SuperFastGPT</a> operated by Gray Generation. By accessing and using our website, you agree to comply with and be bound by the following Terms of Service. If you do not agree with these terms, you should not use our services.
                </p>

                <h2>2. Company Information</h2>
                <p>
                    <strong>Company Name:</strong> Gray Generation<br />
                    <strong>Address:</strong> [Your company address]
                </p>

                <h2>3. Contact Information</h2>
                <p>
                    If you have any questions or concerns regarding these Terms of Service, please contact us at: hello@thegrayportal.com
                </p>

                <h2>4. Introduction</h2>
                <p>
                    SuperFastGPT helps users get things done with AI. We strive to provide accurate and helpful information, but remember that AI is not perfect and it is your responsibility to double-check any information or advice provided.
                </p>

                <h2>5. User Responsibilities</h2>
                <p>
                    By using our website, you agree to:
                </p>
                <ul>
                    <li>Understand that AI technology is imperfect and to verify any information or advice received.</li>
                    <li>Use the website and its resources in a lawful manner.</li>
                </ul>

                <h2>6. Account Creation</h2>
                <p>
                    There are no specific rules regarding the creation and maintenance of user accounts on SuperFastGPT.
                </p>

                <h2>7. Prohibited Activities</h2>
                <p>
                    Users are strictly prohibited from:
                </p>
                <ul>
                    <li>Using any information obtained from SuperFastGPT for nefarious purposes.</li>
                </ul>

                <h2>8. Intellectual Property</h2>
                <p>
                    There are no specific terms regarding intellectual property and user-generated content.
                </p>

                <h2>9. Termination of Service</h2>
                <p>
                    Your access to SuperFastGPT may be terminated if you:
                </p>
                <ul>
                    <li>Attempt to DDOS or hack the website.</li>
                </ul>

                <h2>10. Limitation of Liability</h2>
                <p>
                    There are no special limitations of liability beyond standard legal requirements.
                </p>

                <h2>11. Changes to Terms</h2>
                <p>
                    We reserve the right to update or change these Terms of Service at any time. Users will be informed of any changes via email.
                </p>

                <h2>12. Governing Law</h2>
                <p>
                    These Terms of Service are governed by the laws of the state of Washington (WA).
                </p>

                <h2>13. Miscellaneous</h2>
                <p>
                    There are no additional terms or conditions at this time.
                </p>
            </div>
        </Paper>
    );
}

export default TermsOfServicePage;
